/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online text reverser. Flip text backwards by characters, reverse the order of words, or reverse lines. Emoji-safe and works in your browser.`)
};

const es_rv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversor de texto en línea gratuito. Invierte texto por caracteres, revierte el orden de palabras o invierte líneas. Compatible con emoji y funciona en tu navegador.`)
};

const de_rv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Text-Umkehrer. Kehre Text nach Zeichen um, kehre die Reihenfolge der Wörter um oder kehre Zeilen um. Emoji-sicher und funktioniert in deinem Browser.`)
};

const nl_rv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online tekstomdraaier. Keer tekst om naar tekens, keer de volgorde van woorden om, of keer lijnen om. Veilig voor emoji's en werkt in je browser.`)
};

const fr_rv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverseur de texte en ligne gratuit. Retournez le texte à l'envers par caractères, inversez l'ordre des mots ou inversez les lignes. Sûr pour les emoji et fonctionne dans votre navigateur.`)
};

const it_rv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invertitore di testo online gratuito. Capovolgi il testo al contrario per caratteri, inverti l'ordine delle parole o inverti le righe. Sicuro per emoji e funziona nel tuo browser.`)
};

const pt_br2_rv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversor de texto online gratuito. Vire o texto para trás por caracteres, inverta a ordem das palavras ou inverta as linhas. Seguro para emojis e funciona no seu navegador.`)
};

const pt_rv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversor de texto online gratuito. Inverta texto para trás por caracteres, inverta a ordem das palavras ou inverta linhas. Seguro para emoji e funciona no seu navegador.`)
};

const ja_rv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインテキストリバーサーです。文字ごとにテキストを反転させたり、単語の順序を逆にしたり、行を反転させたりします。絵文字に対応しており、ブラウザで動作します。`)
};

const zh_rv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线文本反转器。按字符将文本倒序翻转，反转单词顺序，或反转行顺序。对表情符号安全，可在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_meta_description", locale)
	if (locale === "en") return en_rv_meta_description(inputs)
	if (locale === "es") return es_rv_meta_description(inputs)
	if (locale === "de") return de_rv_meta_description(inputs)
	if (locale === "nl") return nl_rv_meta_description(inputs)
	if (locale === "fr") return fr_rv_meta_description(inputs)
	if (locale === "it") return it_rv_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_rv_meta_description(inputs)
	if (locale === "pt") return pt_rv_meta_description(inputs)
	if (locale === "ja") return ja_rv_meta_description(inputs)
	return zh_rv_meta_description(inputs)
};